// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"R1-z","displaySixCardTiles":"S1-z"};